<template>
  <div class="password">
    <van-nav-bar :title="title" @click-left="goBack">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="group-content">
      <van-cell-group class="list">
        <van-field v-model="params.password" type="password" clearable placeholder="请输入旧密码">
          <template slot="left-icon">
            <img src="../../assets/img/icon/oldp.png" class="icon" />
          </template>
        </van-field>
        <van-field v-model="params.newPassword" type="password" clearable placeholder="请输入新密码">
          <template slot="left-icon">
            <img src="../../assets/img/icon/passw.png" class="icon" />
          </template>
        </van-field>
        <van-field
          v-model="params.confirmPassword"
          type="password"
          clearable
          placeholder="请再次输入新密码"
        >
          <template slot="left-icon">
            <img src="../../assets/img/icon/passw.png" class="icon" />
          </template>
        </van-field>
      </van-cell-group>
      <!-- <div class="push2"> -->
      <van-button type="info" class="push2" @click="update">确认修改</van-button>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  name: "Password",
  data() {
    return {
      title: "修改登录密码",
      params: {
        password: "",
        newPassword: "",
        confirmPassword: ""
      },
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  created() {},
  computed: {
    verify: function() {
      if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(
          this.params.newPassword
        )
      ) {
        return { flag: false, msg: "密码必须是数字加字母6到16位" };
      }
      if (
        this.params.newPassword.length < 6 ||
        this.params.newPassword.length > 16
      ) {
        return { flag: false, msg: "密码长度在6-16个字符之间" };
      }
      if (this.params.newPassword != this.params.confirmPassword) {
        return { flag: false, msg: "两次输入的密码不一致" };
      }
      return { flag: true, msg: "ok" };
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "Set",
        query: {
        }
      });
    },
    update() {
      if (!this.verify.flag) {
        this.$toast.fail(this.verify.msg);
      } else {
        //console.log(this.params);
        var url = this.Conf.serverUrl + "User/updatePassword" + "?num="+Math.random();
        var data = {
          u_id: this.u_id,
          token: this.token,
          password: md5(this.params.password),
          newPassword: md5(this.params.newPassword)
        };
        this.$axios
          .post(url, this.$qs.stringify(data))
          .then(response => {
            //console.log(response.data);lll
            switch (response.data.code) {
              case 200:
                this.$toast.success(response.data.msg);
                break;
              case 40001:
                this.$toast.fail(response.data.msg);
                break;
            }
          })
          .catch(error => {
            // console.log(error);
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/My/Password.vue